{
  "contact-data-form": {
    "text": {
      "email": "E-mail"
    }
  }
}
